export default function VisitSection() {
  return (
    <section className="py-24 bg-gradient-to-b from-white to-[#ECFDF5]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block mb-6">
            <span className="px-5 py-2 bg-[#10B981] text-white text-sm font-medium rounded-full">
              Home Visit Service
            </span>
          </div>
          <h2 className="text-5xl font-bold text-[#065F46] mb-4" style={{ fontFamily: "'Noto Serif JP', serif" }}>
            訪問整体について
          </h2>
          <p className="text-lg text-[#666666] mt-6">ご自宅で安心して施術を受けられます</p>
        </div>

        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {[
              { icon: 'ri-home-heart-line', title: '通院の負担がない', description: 'ご自宅(もしくは近くのレンタルルーム）までお伺いしますので、移動の負担や時間を気にする必要がありません。天候に左右されることもなく、安心してご利用いただけます。' },
              { icon: 'ri-emotion-happy-line', title: 'リラックスした環境', description: '慣れ親しんだご自宅で施術を受けられるため、心身ともにリラックスした状態で整体を受けることができます。' },
              { icon: 'ri-user-heart-line', title: '高齢の方でも安心', description: '外出が困難な方や、高齢で移動が大変な方でも、ご自宅で専門的な施術を受けることができます。' },
              { icon: 'ri-lightbulb-line', title: '普段の生活環境に合わせた身体指導', description: '実際の生活空間を見ながら、日常動作の改善点や、環境に合わせた身体の使い方をアドバイスできます。' }
            ].map((benefit, index) => (
              <div key={index} className="bg-white rounded-3xl p-8 shadow-lg hover:shadow-2xl transition-all duration-300">
                <div className="w-16 h-16 flex items-center justify-center bg-[#ECFDF5] rounded-2xl mb-6">
                  <i className={`${benefit.icon} text-3xl text-[#10B981]`}></i>
                </div>
                <h3 className="text-xl font-bold text-[#065F46] mb-4">{benefit.title}</h3>
                <p className="text-sm text-[#666666] leading-relaxed">{benefit.description}</p>
              </div>
            ))}
          </div>

          <div className="bg-white border-2 border-[#10B981] rounded-3xl p-8 mb-8 flex items-center gap-6">
            <div className="w-16 h-16 flex items-center justify-center bg-[#ECFDF5] rounded-2xl flex-shrink-0">
              <i className="ri-bear-smile-line text-3xl text-[#10B981]"></i>
            </div>
            <div>
              <h3 className="text-xl font-bold text-[#065F46] mb-2">お子様やペットもご一緒にどうぞ</h3>
              <p className="text-base text-[#666666] leading-relaxed">
                小さなお子様やペットがご一緒でも大丈夫です。<br />
                慣れ親しんだご自宅の環境のまま、安心して施術をお受けいただけます。
              </p>
            </div>
          </div>

          <div className="bg-white border-2 border-[#10B981] rounded-3xl p-8 mb-12 flex items-start gap-6">
            <div className="w-16 h-16 flex items-center justify-center bg-[#ECFDF5] rounded-2xl flex-shrink-0">
              <i className="ri-checkbox-circle-line text-3xl text-[#10B981]"></i>
            </div>
            <div>
              <h3 className="text-xl font-bold text-[#065F46] mb-3">用意していただくもの</h3>
              <p className="text-base text-[#666666] leading-relaxed">
                特にございませんが、強いて言うならエリア内であれば（自称）トライアスリートが自転車（ロードバイク）で訪問しますので、駐輪スペースの確保はお願いしたいです。（エリア外は公共交通機関を利用します）<br />
                屋内ではリビングなどで横になれるスペースがあれば充分です。服装は動きやすいジャージなどで大丈夫です。
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-br from-[#10B981] to-[#059669] rounded-3xl p-12 shadow-2xl text-white text-center">
            <div className="max-w-3xl mx-auto">
              <div className="w-20 h-20 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-6">
                <i className="ri-map-pin-line text-4xl text-white"></i>
              </div>
              <h3 className="text-3xl font-bold mb-6" style={{ fontFamily: "'Noto Serif JP', serif" }}>訪問エリア（大阪市北部、摂津市、吹田市、守口市など）</h3>
              <p className="text-xl mb-8" style={{ lineHeight: '2.0' }}>
                お気軽にご相談ください。<br />
                エリア外の方も、まずはお問い合わせください。
              </p>
              <div className="inline-flex items-center gap-3 px-8 py-4 bg-white text-[#10B981] font-bold rounded-full">
                <i className="ri-phone-line text-xl"></i>
                <span className="text-lg">090-1895-9421</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
